export default __webpack_public_path__ + "03294a88bccebf7c551035c496eb6488.png";